import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Menu, MenuModule } from 'primeng/menu';
import { FcpMenuService } from './fcp-menu.service';

@Component({
    selector: 'fcp-menu',
    standalone: true,
    imports: [CommonModule, MenuModule],
    styleUrl: './fcp-menu.component.less',
    encapsulation: ViewEncapsulation.Emulated,
    host: {
        '[attr.data-e2e-hook]': 'e2e'
    },
    template: `<p-menu
        #menuRef
        [model]="model"
        [popup]="popup"
        [autoZIndex]="autoZIndex"
        [baseZIndex]="baseZIndex"
        [showTransitionOptions]="showTransitionOptions"
        [hideTransitionOptions]="hideTransitionOptions"
        [ariaLabel]="ariaLabel"
        [ariaLabelledBy]="ariaLabelledBy"
        [id]="id"
        [tabindex]="tabindex"
        [appendTo]="appendTo"
        (onShow)="onShow.emit($event)"
        (onHide)="onHide.emit($event)"
        (onBlur)="onBlur.emit($event)"
        (onFocus)="onFocus.emit($event)"
    >
    </p-menu>`
})
export class FcpMenuComponent {
    @Input() e2e: string | null = null;
    @Input() model: MenuItem[] | null = null;
    @Input() popup = false;
    @Input() autoZIndex = true;
    @Input() baseZIndex = 0;
    @Input() showTransitionOptions = '225ms ease-out';
    @Input() hideTransitionOptions = '195ms ease-in';
    @Input() ariaLabel: string | undefined;
    @Input() ariaLabelledBy: string | undefined;
    @Input() id: string | undefined;
    @Input() tabindex = 0;
    @Input() appendTo: HTMLElement | string | undefined;

    @Output() onShow = new EventEmitter<Event>();
    @Output() onHide = new EventEmitter<Event>();
    @Output() onBlur = new EventEmitter<Event>();
    @Output() onFocus = new EventEmitter<Event>();

    @ViewChild('menuRef') menuRef: Menu | undefined;

    private menuService = inject(FcpMenuService);

    getServiceMenuItems(): MenuItem[] {
        return this.menuService.getMenuItems() as MenuItem[];
    }

    useServiceItems(): void {
        this.model = this.getServiceMenuItems();
    }

    toggle(event: Event): void {
        this.menuRef?.toggle(event);
    }

    show(event: Event): void {
        this.menuRef?.show(event);
    }

    hide(): void {
        this.menuRef?.hide();
    }
}
